import { Dispatch } from 'redux';
import { slice } from './slice';
import { cloneDeep } from 'lodash';

const openModal =
  (actionType: string, props: { [key: string]: any } = {}) =>
  (dispatch: Dispatch) => {
    dispatch(slice.actions.setModal({ actionType, props: cloneDeep(props) }));
  };

const modalActions = {
  ...slice.actions,
  openModal,
};

export default modalActions;
